/**
 * @file: useEntitledSidebarItems.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useStoreFeatureLookup } from '@euler/functions/entitlements/useStoreFeature';
import { useMemo } from 'react';
import type { SidebarItem } from './AppSidebar';

/** The items whose feature the store has, each with its trial end. */
export function useEntitledSidebarItems(
  items: readonly SidebarItem[],
): SidebarItem[] {
  const featureOf = useStoreFeatureLookup();
  return useMemo(
    () =>
      items.flatMap(item => {
        if (item.feature == null) return [item];
        const access = featureOf(item.feature);
        return access.enabled
          ? [{ ...item, trialEndsAt: access.trialEndsAt }]
          : [];
      }),
    [items, featureOf],
  );
}
